import { default as _91_46_46_46cms_93UDja09qr0tMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93OqUCGrbnLTMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexQqjV4T2AbwMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93hK3sOLClwdMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/akcii/[...slug].vue?macro=true";
import { default as indexRYws6vphU2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_938dSMhgd7BcMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/articles/[...slug].vue?macro=true";
import { default as indexHtKdw7EMiHMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/articles/index.vue?macro=true";
import { default as indexeyXdKrKprFMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/authorization/index.vue?macro=true";
import { default as indexyIzyu9s6BnMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_9329RFAtCtX3Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93ewkRSHx3xNMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/catalog/[...slug].vue?macro=true";
import { default as indexvwml2EqPaaMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93Kak2yqiByhMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultBZX3doiagNMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/catalogsearch/result.vue?macro=true";
import { default as indexaD5nyLlxyKMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_93iVjOTCd7AIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93vVGGnMU5RqMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/fabriki/[...slug].vue?macro=true";
import { default as indexGu83kVfuCYMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/fabriki/index.vue?macro=true";
import { default as _91hash_93XT3daSxoYhMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/order-status/[hash].vue?macro=true";
import { default as _91_46_46_46slug_93Ypn3Ks1AzjMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/product/[...slug].vue?macro=true";
import { default as index9WabpSaTBMMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/profile/index.vue?macro=true";
import { default as indexSbOFJG52CuMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/profile/orders/index.vue?macro=true";
import { default as indexRsDefBQqVMMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93CrmGbnT8zIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/sets/[...slug].vue?macro=true";
import { default as indexIQ13TcRCGaMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93UDja09qr0tMeta?.name ?? "cms",
    path: _91_46_46_46cms_93UDja09qr0tMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93UDja09qr0tMeta || {},
    alias: _91_46_46_46cms_93UDja09qr0tMeta?.alias || [],
    redirect: _91_46_46_46cms_93UDja09qr0tMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93OqUCGrbnLTMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93OqUCGrbnLTMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93OqUCGrbnLTMeta || {},
    alias: _91_46_46_46slug_93OqUCGrbnLTMeta?.alias || [],
    redirect: _91_46_46_46slug_93OqUCGrbnLTMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexQqjV4T2AbwMeta?.name ?? "3d-projects",
    path: indexQqjV4T2AbwMeta?.path ?? "/3d-projects",
    meta: indexQqjV4T2AbwMeta || {},
    alias: indexQqjV4T2AbwMeta?.alias || [],
    redirect: indexQqjV4T2AbwMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93hK3sOLClwdMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93hK3sOLClwdMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93hK3sOLClwdMeta || {},
    alias: _91_46_46_46slug_93hK3sOLClwdMeta?.alias || [],
    redirect: _91_46_46_46slug_93hK3sOLClwdMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexRYws6vphU2Meta?.name ?? "akcii",
    path: indexRYws6vphU2Meta?.path ?? "/akcii",
    meta: indexRYws6vphU2Meta || {},
    alias: indexRYws6vphU2Meta?.alias || [],
    redirect: indexRYws6vphU2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_938dSMhgd7BcMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_938dSMhgd7BcMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_938dSMhgd7BcMeta || {},
    alias: _91_46_46_46slug_938dSMhgd7BcMeta?.alias || [],
    redirect: _91_46_46_46slug_938dSMhgd7BcMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexHtKdw7EMiHMeta?.name ?? "articles",
    path: indexHtKdw7EMiHMeta?.path ?? "/articles",
    meta: indexHtKdw7EMiHMeta || {},
    alias: indexHtKdw7EMiHMeta?.alias || [],
    redirect: indexHtKdw7EMiHMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexeyXdKrKprFMeta?.name ?? "authorization",
    path: indexeyXdKrKprFMeta?.path ?? "/authorization",
    meta: indexeyXdKrKprFMeta || {},
    alias: indexeyXdKrKprFMeta?.alias || [],
    redirect: indexeyXdKrKprFMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexyIzyu9s6BnMeta?.name ?? "cart",
    path: indexyIzyu9s6BnMeta?.path ?? "/cart",
    meta: indexyIzyu9s6BnMeta || {},
    alias: indexyIzyu9s6BnMeta?.alias || [],
    redirect: indexyIzyu9s6BnMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_9329RFAtCtX3Meta?.name ?? "cart-success-id",
    path: _91_46_46_46id_9329RFAtCtX3Meta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_9329RFAtCtX3Meta || {},
    alias: _91_46_46_46id_9329RFAtCtX3Meta?.alias || [],
    redirect: _91_46_46_46id_9329RFAtCtX3Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93ewkRSHx3xNMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93ewkRSHx3xNMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93ewkRSHx3xNMeta || {},
    alias: _91_46_46_46slug_93ewkRSHx3xNMeta?.alias || [],
    redirect: _91_46_46_46slug_93ewkRSHx3xNMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexvwml2EqPaaMeta?.name ?? "catalog",
    path: indexvwml2EqPaaMeta?.path ?? "/catalog",
    meta: indexvwml2EqPaaMeta || {},
    alias: indexvwml2EqPaaMeta?.alias || [],
    redirect: indexvwml2EqPaaMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Kak2yqiByhMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93Kak2yqiByhMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93Kak2yqiByhMeta || {},
    alias: _91_46_46_46slug_93Kak2yqiByhMeta?.alias || [],
    redirect: _91_46_46_46slug_93Kak2yqiByhMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultBZX3doiagNMeta?.name ?? "catalogsearch-result",
    path: resultBZX3doiagNMeta?.path ?? "/catalogsearch/result",
    meta: resultBZX3doiagNMeta || {},
    alias: resultBZX3doiagNMeta?.alias || [],
    redirect: resultBZX3doiagNMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: indexaD5nyLlxyKMeta?.name ?? "clear-page-slider",
    path: indexaD5nyLlxyKMeta?.path ?? "/clear-page-slider",
    meta: indexaD5nyLlxyKMeta || {},
    alias: indexaD5nyLlxyKMeta?.alias || [],
    redirect: indexaD5nyLlxyKMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93iVjOTCd7AIMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93iVjOTCd7AIMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93iVjOTCd7AIMeta || {},
    alias: _91_46_46_46slug_93iVjOTCd7AIMeta?.alias || [],
    redirect: _91_46_46_46slug_93iVjOTCd7AIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93vVGGnMU5RqMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93vVGGnMU5RqMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93vVGGnMU5RqMeta || {},
    alias: _91_46_46_46slug_93vVGGnMU5RqMeta?.alias || [],
    redirect: _91_46_46_46slug_93vVGGnMU5RqMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexGu83kVfuCYMeta?.name ?? "fabriki",
    path: indexGu83kVfuCYMeta?.path ?? "/fabriki",
    meta: indexGu83kVfuCYMeta || {},
    alias: indexGu83kVfuCYMeta?.alias || [],
    redirect: indexGu83kVfuCYMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91hash_93XT3daSxoYhMeta?.name ?? "order-status-hash",
    path: _91hash_93XT3daSxoYhMeta?.path ?? "/order-status/:hash()",
    meta: _91hash_93XT3daSxoYhMeta || {},
    alias: _91hash_93XT3daSxoYhMeta?.alias || [],
    redirect: _91hash_93XT3daSxoYhMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/order-status/[hash].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93Ypn3Ks1AzjMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_93Ypn3Ks1AzjMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93Ypn3Ks1AzjMeta || {},
    alias: _91_46_46_46slug_93Ypn3Ks1AzjMeta?.alias || [],
    redirect: _91_46_46_46slug_93Ypn3Ks1AzjMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index9WabpSaTBMMeta?.name ?? "profile",
    path: index9WabpSaTBMMeta?.path ?? "/profile",
    meta: index9WabpSaTBMMeta || {},
    alias: index9WabpSaTBMMeta?.alias || [],
    redirect: index9WabpSaTBMMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexSbOFJG52CuMeta?.name ?? "profile-orders",
    path: indexSbOFJG52CuMeta?.path ?? "/profile/orders",
    meta: indexSbOFJG52CuMeta || {},
    alias: indexSbOFJG52CuMeta?.alias || [],
    redirect: indexSbOFJG52CuMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexRsDefBQqVMMeta?.name ?? "recently",
    path: indexRsDefBQqVMMeta?.path ?? "/recently",
    meta: indexRsDefBQqVMMeta || {},
    alias: indexRsDefBQqVMMeta?.alias || [],
    redirect: indexRsDefBQqVMMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93CrmGbnT8zIMeta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93CrmGbnT8zIMeta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93CrmGbnT8zIMeta || {},
    alias: _91_46_46_46slug_93CrmGbnT8zIMeta?.alias || [],
    redirect: _91_46_46_46slug_93CrmGbnT8zIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexIQ13TcRCGaMeta?.name ?? "wishlist",
    path: indexIQ13TcRCGaMeta?.path ?? "/wishlist",
    meta: indexIQ13TcRCGaMeta || {},
    alias: indexIQ13TcRCGaMeta?.alias || [],
    redirect: indexIQ13TcRCGaMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260929134257/pages/wishlist/index.vue").then(m => m.default || m)
  }
]